module.exports = __webpack_public_path__ + "img/yiyangxianAppImage.6b4d554c.png";